import { motion } from "framer-motion";
import React from "react";

function Overlay({ onClick, cursor }) {
    const backdropVariants = {
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
    };

    return (
        <motion.div
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            transition={{ duration: 0.3 }}
            className="fixed w-full h-full top-0 left-0 bg-black z-40 bg-opacity-50 cursor-pointer"
            onClick={onClick}
        />
    );
}

export default Overlay;
